import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=3d548966"
import script from "./Email.vue?vue&type=script&lang=ts"
export * from "./Email.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports